export default __webpack_public_path__ + "7db5ff1d514a719ac743d35db0c032e7.svg";